import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { AuthenticationService } from '../auth.service';
import { CognitoAuthenticationAdapter } from './cognito-authentication-adapter';
import { CognitoAuthenticationService } from './cognito-authentication.service';
import { CognitoHttpService } from './cognito-http.service';
import { CognitoStorageAdapter } from './cognito-storage-adapter';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    CognitoHttpService,
    CognitoAuthenticationService,
    { provide: AuthenticationService, useClass: CognitoAuthenticationAdapter },
    { provide: OAuthStorage, useClass: CognitoStorageAdapter }
  ]
})
export class CognitoAuthenticationModule {}
